import React from 'react';
import './PrivacyPolicyComponent.css';

const DeleteAccount = () => {
  return (
    <div className="privacy-policy-container">
      <h1>Delete Account & Data Request</h1>

      <p className="effective-date">
        <strong>Effective Date:</strong> April 18, 2026
      </p>

      <p className="intro">
        Skhool is a school management platform owned and operated by XPETO TECHNOLOGIES PRIVATE LIMITED.
        This page explains how users of the Skhool web application and mobile application can request
        account deletion, access removal, or deletion of personal data associated with their school account.
        In most cases, the school that created the account is responsible for approving and processing the request.
      </p>

      <section className="policy-section">
        <h2>Who Can Request Deletion?</h2>
        <p>
          Skhool accounts are usually created and managed by the school. Students, parents, teachers, staff,
          drivers, and school administrators can request deletion or access removal through their school admin.
          For student records, the school may need to retain some information as required by academic,
          financial, attendance, legal, or regulatory obligations.
        </p>
      </section>

      <section className="policy-section">
        <h2>How to Request Account Deletion</h2>
        <ul className="policy-list">
          <li>Contact your school administrator and ask them to remove your Skhool login access or delete eligible account data.</li>
          <li>If you cannot reach the school admin, email <a href="mailto:support@skhool.in">support@skhool.in</a> from your registered email address, if available.</li>
          <li>Use the subject line: <strong>Delete My Skhool Account</strong>.</li>
          <li>Include your full name, registered mobile number or email, school name, user role, and reason for deletion.</li>
          <li>Skhool support may verify the request with the school before any school-controlled data is removed.</li>
        </ul>
      </section>

      <section className="policy-section">
        <h2>What Will Be Deleted or Disabled?</h2>
        <ul className="policy-list">
          <li>Your login access may be disabled or removed by the school admin from the Skhool mobile and web applications.</li>
          <li>Personal profile details such as contact information, device tokens, and app access records may be deleted where allowed.</li>
          <li>Push notification tokens associated with your device may be removed.</li>
          <li>Support messages related to the deletion request may be retained for audit and compliance purposes.</li>
        </ul>
      </section>

      <section className="policy-section">
        <h2>Data That May Be Retained</h2>
        <p>
          Some school records may need to be retained by the school or by Skhool on behalf of the school.
          This may include academic records, fee records, attendance records, exam records, certificates,
          reports, invoices, audit logs, and legal compliance records. Retention depends on school policy,
          applicable law, and contractual obligations.
        </p>
      </section>

      <section className="policy-section">
        <h2>Processing Time</h2>
        <p>
          If the request is sent directly to Skhool support, we aim to acknowledge it within 7 business days.
          Completion time may vary depending on verification, school approval, legal retention requirements,
          and the type of account or data involved.
        </p>
      </section>

      <section className="policy-section contact-section">
        <h2>Contact for Account Deletion Support</h2>
        <address className="company-address">
          <strong>XPETO TECHNOLOGIES PRIVATE LIMITED</strong><br />
          Product: Skhool School Management Platform<br />
          Business PAN: AAACX5637K<br />
          <strong>Email:</strong> <a href="mailto:support@skhool.in">support@skhool.in</a><br />
          <strong>Request subject:</strong> Delete My Skhool Account<br />
          <strong>Primary deletion contact:</strong> Your school administrator
        </address>
      </section>

      <p className="last-updated">
        Last updated: April 18, 2026
      </p>
    </div>
  );
};

export default DeleteAccount;
